<template>
  <div>
      <div class="banner">
        <div class="wrap">
          <a-carousel :autoplay="true">
            <div>
              <div class="item">
                <div class="info">
                  <div class="title">大量高比率分成，期待您的加入</div>
                  <div class="desc">海量正版软件，官方授权资源，一键生成专属链接和海报。高比率佣金等您来拿！</div>
                  <div style="margin-top:60px"><a-button shape="round" size="large" type="ghost" @click="$store.commit('showLoginModal',2)">我要成为推广者，赚取佣金</a-button></div>
                </div>
                <div class="img">
                  <img src="../assets/imgs/5.svg" alt="">
                </div>
              </div>
            </div>
            <div>
              <div class="item">
                <div class="info">
                  <div class="title">推广数据一目了然，支持一键提现</div>
                  <div class="desc">推广数据看板清晰明了，访问点击、订单转换数据实时更新，多种提现方式任君选择。</div>
                  <div style="margin-top:60px"><a-button shape="round" size="large" type="ghost" @click="$store.commit('showLoginModal',1)">我是推广者，登录查看收益</a-button></div>
                </div>
                <div class="img">
                  <img src="../assets/imgs/3.svg" alt="">
                </div>
              </div>
            </div>
          </a-carousel>
        </div>
      </div>
      <div class="box-title" id="flow">4步即可轻松获得佣金</div>
      <div class="flow-box wrap">
        <div class="item">
          <img src="../assets/imgs/1.svg" alt="">
          <div>注册成为联盟推广伙伴</div>
          <i class="arrow">
          <svg t="1634201794870" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="32187" width="80" height="80"><path d="M333.824 794.624c-141.312 0-296.96-151.552-305.152-157.696l6.144-6.144c2.048 2.048 192.512 186.368 337.92 151.552 59.392-14.336 104.448-65.536 133.12-149.504 28.672-88.064 75.776-139.264 139.264-155.648 149.504-36.864 337.92 145.408 346.112 153.6l-6.144 6.144c-2.048-2.048-192.512-186.368-337.92-151.552-59.392 14.336-104.448 65.536-133.12 149.504-28.672 88.064-75.776 139.264-139.264 155.648-14.336 2.048-26.624 4.096-40.96 4.096z" fill="#ffffff" p-id="32188"></path><path d="M978.944 536.576h14.336v106.496h-14.336z" fill="#ffffff" p-id="32189"></path><path d="M882.688 626.688h112.64v14.336h-112.64z" fill="#ffffff" p-id="32190"></path></svg>
          </i>
        </div>
        <div class="item">
          <img src="../assets/imgs/9.svg" alt="">
          <div>获取商品推广专属链接</div>
          <i class="arrow">
          <svg t="1634201794870" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="32187" width="80" height="80"><path d="M333.824 794.624c-141.312 0-296.96-151.552-305.152-157.696l6.144-6.144c2.048 2.048 192.512 186.368 337.92 151.552 59.392-14.336 104.448-65.536 133.12-149.504 28.672-88.064 75.776-139.264 139.264-155.648 149.504-36.864 337.92 145.408 346.112 153.6l-6.144 6.144c-2.048-2.048-192.512-186.368-337.92-151.552-59.392 14.336-104.448 65.536-133.12 149.504-28.672 88.064-75.776 139.264-139.264 155.648-14.336 2.048-26.624 4.096-40.96 4.096z" fill="#ffffff" p-id="32188"></path><path d="M978.944 536.576h14.336v106.496h-14.336z" fill="#ffffff" p-id="32189"></path><path d="M882.688 626.688h112.64v14.336h-112.64z" fill="#ffffff" p-id="32190"></path></svg>
          </i>
        </div>
        <div class="item">
          <img src="../assets/imgs/8.svg" alt="">
          <div>分享给粉丝或好友购买</div>
          <i class="arrow">
          <svg t="1634201794870" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="32187" width="80" height="80"><path d="M333.824 794.624c-141.312 0-296.96-151.552-305.152-157.696l6.144-6.144c2.048 2.048 192.512 186.368 337.92 151.552 59.392-14.336 104.448-65.536 133.12-149.504 28.672-88.064 75.776-139.264 139.264-155.648 149.504-36.864 337.92 145.408 346.112 153.6l-6.144 6.144c-2.048-2.048-192.512-186.368-337.92-151.552-59.392 14.336-104.448 65.536-133.12 149.504-28.672 88.064-75.776 139.264-139.264 155.648-14.336 2.048-26.624 4.096-40.96 4.096z" fill="#ffffff" p-id="32188"></path><path d="M978.944 536.576h14.336v106.496h-14.336z" fill="#ffffff" p-id="32189"></path><path d="M882.688 626.688h112.64v14.336h-112.64z" fill="#ffffff" p-id="32190"></path></svg>
          </i>
        </div>
        <div class="item">
          <img src="../assets/imgs/10.svg" alt="">
          <div>订单完成赚取高额佣金</div>

        </div>
      </div>
      <div class="wrap advantage-box" id="our">
          <div class="left">
            <div class="title">我们的优势</div>
            <div class="desc">
             专业的团队打造贴心的服务体验，官方正版授权货源，让用户放心购买，售前售后一站式服务乐无忧。
            </div>
          </div>
          <div class="right">
            <div class="adv-item">
                <img src="../assets/imgs/6.svg" alt="">
                <div class="title">
                  海量正版软件资源
                </div>
                <div class="desc">
                  厂商直接授权，一手货源让商品质量更有保障。公司资质齐全，专业的服务团队为客户提供一条龙的贴心服务。
                </div>
            </div>
            <div class="adv-item">
                <img src="../assets/imgs/7.svg" alt="">
                <div class="title">
                  高额比率佣金分成
                </div>
                <div class="desc">
                  筛选自己感兴趣软件，一键生成专属推广链接，自定义生成所需规格推广专属推广海报，分享出去，获得高额佣金。
                </div>
            </div>
            <div class="adv-item">
                <img src="../assets/imgs/4.svg" alt="">
                <div class="title">
                  轻松推广快捷提现
                </div>
                <div class="desc">
                  支持微信、支付宝、银行卡一键自定义数额或者全额快捷提现，操作简单方便。提现状态和数据列表清晰对比数据。
                </div>
            </div>
          </div>
      </div>

      <div class="box-title" id="partner">合作伙伴</div>
      <div class="wrap">
        <div class=" partner-box">
          <div>
            <img src="../assets/partners/1.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/2.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/3.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/4.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/5.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/6.svg" alt="">
          </div>
          <div>
            <img src="../assets/partners/7.svg" alt="">
          </div>
          <div>
            <img height="60" src="../assets/partners/8.svg" alt="">
          </div>
        </div>
      </div>
      
  </div>
</template>

<script>
export default {
  name: '',
  data(){
    return {
      info:{}
    }
  },
  mounted(){
    
  },
  methods:{
    getIndexData(){
      this.$http.get('index').then((res)=>{
        console.log(res);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .banner{
    background: #141d7d;
    height: 400px;
  }
  .banner .item{
    color: #fff;
    
    display: flex;
    height: 100%;
  }
  .banner .item .info{
    flex: 1;
    padding: 60px 0;
  }
  .banner .item .title{
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .banner .item .desc{
    margin-bottom: 30px;
  }
  .banner .item .img{
    flex: 1;
    text-align: right;
    padding: 60px 0;
    height: 400px;
  }
.banner .item .img img{
   height: 100%;
   display: inline-block;
}

.box-title{
  font-size: 28px;
  text-align: center;
  margin: 90px 0;
  color: #fff;
}
.flow-box{
  display: flex;
  margin-bottom: 45px;
}
.flow-box .item {
  color: #fff;
  text-align: center;
  flex: 1;
  position: relative;
}
.flow-box .item .arrow{
  position: absolute;
  right: -40px;
  top: calc(50% - 40px);
}
.flow-box .item img{
  height: 100px;
  margin-bottom: 25px;
}

.advantage-box{
  background: #4f46bb;
  position: relative;
  margin-top: 100px;
  display: flex;
}

.advantage-box .left{
  flex: 1;
  color: #fff;
  padding: 60px 20px 60px 40px;
}
.advantage-box .left .title{
  font-size: 28px;
  margin-bottom: 20px;
}
.advantage-box .right{
  flex: 3;
  display: flex;
  padding: 60px 20px;
}

.advantage-box .right .adv-item{
  color: #fff;
  padding: 0 20px;
  text-align: center;
  flex: 1;
}
.advantage-box .right .adv-item img{
  height: 120px;
  border-radius: 10px;
}
.advantage-box .right .adv-item .title{
  margin-top: 1rem;
  font-size: 18px;
}
.advantage-box .right .adv-item .desc{
  margin-top: 7px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.partner-box{
  display: flex;
  margin-right: -30px;
  text-align: center;
  flex-wrap: wrap;
  margin-bottom: 90px;
}
.partner-box>div{
  width: calc(25% - 30px);
  margin-right: 30px;
  text-align: center;
  margin-bottom: 40px;
  background: rgba(255, 255, 255, 0.1);
  padding: 10px 60px;
  line-height: 83px;
}
.partner-box img{
  width: 100%;
}
</style>
